"use client"

import { ReactNode } from "react"

type Props = {
  children: ReactNode
  className?: string
}

export default function TextRegularM({
  children,
  className = "",
}: Props) {
  return (
    <p
      className={`
        flex
        items-center
        py-1
        //text-[8px]
        text-[.7rem]
        font-normal
        leading-4
        break-words
        normal-case
        tracking-normal
        opacity-[60%]

        //md:text-[9px]

        ${className}
      `}
    >
      {children}
    </p>
  )
}